module.exports = __webpack_public_path__ + "img/text-icon.95940338.svg";